import { css } from 'lit';

export const nsChoiceStyles = css`
  wa-radio,
  wa-checkbox {
    --wa-form-control-toggle-size: 15px;
    --wa-form-control-border-width: 0;
    /* Not chosen reads empty (a white circle in the ring), chosen reads filled (green with a dark dot or tick), so the pale
       green never looks emptier than the unchosen state */
    --wa-form-control-background-color: var(--ns-theme-white);
    --wa-form-control-activated-color: var(--ns-theme-green);
    --wa-form-control-value-color: var(--ns-theme-type);
    --wa-color-focus: var(--ns-theme-purple);
    --wa-focus-ring-offset: 2px;

    font-size: var(--wa-font-size-xs);
  }

  wa-radio,
  wa-checkbox::part(base) {
    align-items: center;
  }

  wa-radio::part(control),
  wa-checkbox::part(control) {
    border-radius: var(--wa-border-radius-circle);
    box-shadow:
      0 0 0 1px var(--ns-theme-white),
      0 0 0 2px var(--ns-theme-type);
  }

  wa-radio:state(checked)::part(control) {
    background-color: var(--wa-form-control-activated-color);
  }

  wa-checkbox:state(checked)::part(control) {
    background-color: var(--wa-form-control-activated-color);
  }

  wa-radio::part(checked-icon),
  wa-checkbox::part(checked-icon) {
    color: var(--wa-form-control-value-color);
  }

  wa-radio-group::part(form-control-label) {
    margin: 0;
    color: inherit;
    font: inherit;
  }

  /* A question given as the label attribute is spaced from its choices, as a slotted label's mb-2 does */
  wa-radio-group[label]::part(form-control-label) {
    margin-block-end: var(--wa-space-xs);
  }
`;
